export default {"src":"/_next/static/media/icon-go-to-top.a3fbaf3e.svg","height":49,"width":48};